export function videoPlayOnScroll() {
    const lazyVideo = document.querySelectorAll('video.play-on-scroll');
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            let $video = entry.target;
            if (entry.isIntersecting) {
                $video.play();
            } else {
                $video.pause();
            }
        });
    });

    lazyVideo.forEach(video => {
        observer.observe(video);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoPlayOnScroll.js